import { formatPhoneNumber } from "@/lib/phoneHelpers";
import { JobApplicationWithReviews } from "../types";

type SearchableApplication = {
  applicant?: {
    firstName?: string;
    lastName?: string;
    pgaId?: string;
    primarySection?: { name?: string };
  };
  email?: string;
  phone?: string;
};

export function filterJobApplicationsBySearch<T extends SearchableApplication>(
  applications: T[],
  searchValue: string
): T[] {
  const query = searchValue.trim().toLowerCase();
  if (!query) return applications;

  return applications.filter((row) => {
    const name = `${row.applicant?.firstName || ""} ${row.applicant?.lastName || ""}`.trim().toLowerCase();
    const pgaId = row.applicant?.pgaId?.toLowerCase() || "";
    const email = row.email?.toLowerCase() || "";
    const phone = row.phone?.toLowerCase() || "";
    const formattedPhone = formatPhoneNumber(row.phone ?? null)?.toLowerCase() || "";
    const section = row.applicant?.primarySection?.name?.toLowerCase() || "";

    return [name, pgaId, email, phone, formattedPhone, section].some((field) => field.includes(query));
  });
}

export function canExpandApplicationReviews(application: JobApplicationWithReviews) {
  const reviews = application.reviews?.filter((review) => !review.isRecommendation) || [];
  return reviews.length > 0 && application.reviewScoreAverage != null;
}

export function formatApplicationReviewsSummary(application: JobApplicationWithReviews, reviewCount: number) {
  if (!canExpandApplicationReviews(application)) {
    return "--";
  }

  const avg = application.reviewScoreAverage;
  if (avg == null) {
    return "--";
  }

  return `${reviewCount} / ${avg.toFixed(2)}`;
}
